import {
  APIProvider,
  ControlPosition,
  MapControl,
  AdvancedMarker,
  Map,
  useAdvancedMarkerRef,
  InfoWindow,
} from '@vis.gl/react-google-maps';
import PlaceAutocomplete from './PlaceAutoComplete';
import MapHandler from './MapHandler';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useCallback } from 'react';
import { useGoogleMap } from './GoogleMapContext';
import { Box, Button, Typography } from '@mui/material';
import './googleMap.css';
import Constants from '../utils/constants';
const GoogleMapModal = () => {
  const { setIsChoosing, setSiteAddress, setCurrentLoc, currentLoc } =
    useGoogleMap();

  const [selectedPlace, setSelectedPlace] = useState<any>();
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [infoWindowShown, setInfoWindowShown] = useState(false);

  const handleMarkerClick = useCallback(() => {
    setInfoWindowShown((isShown) => !isShown);
  }, []);

  const handleClose = useCallback(() => setInfoWindowShown(false), []);

  const handleChoose = () => {
    setSiteAddress(selectedPlace.formatted_address);
    setCurrentLoc({
      lat: selectedPlace.geometry.location.lat(),
      lng: selectedPlace.geometry.location.lng(),
    });
    setInfoWindowShown(false);
    setIsChoosing(false);
  };

  return (
    <Box
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        zIndex: 9999,
      }}
    >
      <Box
        style={{
          width: '90%',
          height: '80%',
          backgroundColor: 'white',
          padding: '32px',
          display: 'grid',
          gridTemplateRows: 'min-content',
          gap: '16px',
        }}
      >
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h5" style={{ fontWeight: 'bold' }}>
            Add Location
          </Typography>
          <Button onClick={() => setIsChoosing(false)}>
            <CloseIcon />
          </Button>
        </Box>
        <APIProvider
          apiKey={Constants.GOOGLE_API_KEY}
          solutionChannel="GMP_devsite_samples_v3_rgmautocomplete"
        >
          <Map
            mapId={'bf51a910020fa25a'}
            defaultZoom={17}
            defaultCenter={{
              lat: Number(currentLoc.lat),
              lng: Number(currentLoc.lng),
            }}
            gestureHandling={'greedy'}
            disableDefaultUI={true}
          >
            <AdvancedMarker
              ref={markerRef}
              position={null}
              onClick={handleMarkerClick}
            />
            {infoWindowShown && (
              <InfoWindow anchor={marker} onClose={handleClose}>
                <h2>{selectedPlace.name}</h2>
                <p>{selectedPlace.formatted_address}</p>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                  onClick={handleChoose}
                >
                  Choose
                </button>
              </InfoWindow>
            )}
          </Map>
          <MapControl position={ControlPosition.TOP}>
            <div className="autocomplete-control">
              <PlaceAutocomplete onPlaceSelect={setSelectedPlace} />
            </div>
          </MapControl>
          <MapHandler place={selectedPlace} marker={marker} />
        </APIProvider>
      </Box>
    </Box>
  );
};

export default GoogleMapModal;
